/* @flow */

import type { Ingredient } from '../../pizza/fields/domain/pizza';

const ingredientNames = {
  thin_crust: 'うすいきじ',
  normal_crust: 'ふつうのきじ',
  thick_crust: 'ふっくらきじ',
  tomato_sauce: 'トマトソース',
  white_sauce: 'ホワイトソース',
  basil_sauce: 'バジルソース',
  toppings: {
    bell_peeper: 'ピーマン',
    tomato: 'トマト',
    corn: 'コーン',
    salami: 'サラミ',
    bacon: 'ベーコン',
    teriyaki_chicken: 'チキン',
    crab: 'カニ',
    squid: 'イカ',
    shrimp: 'エビ',
  },
};

export const ingredientName = (ingredient: Ingredient): string => {
  if (typeof ingredient === 'string') {
    return ingredientNames[ingredient];
  } else {
    return ingredientNames.toppings[ingredient.topping];
  }
};
